module.exports = __webpack_public_path__ + "img/logo.61ab175b.svg";